// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__143ol","title":"InfoRow_title__1mqVl"};